import Icon from 'veui/components/Icon'
import { IconTimes } from 'dls-icons-vue'

Icon.register('times', IconTimes)
